import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, AbstractControl  } from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../utils/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/utils/services/loader.service';

@Component({
  selector: 'app-all-categories',
  templateUrl: './all-categories.component.html',
  styleUrls: ['./all-categories.component.scss']
})
export class AllCategoriesComponent implements OnInit {
  postDate:any
  addNewsForm!: FormGroup;
  private category: string;
  public minDate = undefined;
  private news_id: any;
  public news_type: any;
  public SubCats: any;
  private _userId: string = localStorage.getItem("id");
  public cancelCatRoute: string;
  public isAuthLoading = false;
  public isAuthDisabled = false;
  config_ck = {
    uiColor: '#ffffff',
    toolbarGroups: [
 
    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
    { name: 'colors' }],
   resize_enabled: false,
    removePlugins: 'elementspath,save,magicline',
    extraPlugins: 'justify',
    colorButton_foreStyle: {
       element: 'font',
       attributes: { 'color': '#(color)' }
    },
    height: 188,
    removeDialogTabs: 'image:advanced;link:advanced',
    removeButtons: 'Subscript,Superscript,Anchor,Source,Table',
    format_tags: 'p;h1;h2;h3;pre;div'
 }
activeTillDate: any;
  activeTillDateWithTime: string;
  constructor(
    private formBuilder: FormBuilder,
    private config: NgbDatepickerConfig,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private LoaderService:LoaderService,
    private fb: FormBuilder
  ) {
    const current = new Date();
    this.minDate = {
      year: current.getFullYear(),
      month: current.getMonth() + 1,
      day: current.getDate()
    };
    
  }
  public userData = JSON.parse(localStorage.getItem("userInfo"));

  @ViewChild('importImg', { static: false }) importImg: ElementRef;
  @ViewChild('importVdo', { static: false }) importVdo: ElementRef;
  @ViewChild('importFile', { static: false }) importFile: ElementRef;
  @ViewChild('importLogoImg', { static: false }) importLogoImg: ElementRef;
  // @ViewChild('importThumbnailImg', { static: false }) importThumbnailImg: ElementRef;

  urlValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (!control.value) return null; // Allow empty value
    const urlPattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([/?].*)?$/;
    return urlPattern.test(control.value) ? null : { invalidUrl: true };
  }
  
  ngOnInit(): void {
    this.LoaderService.showLoader()
    this.category = this.router.url.split('/')[1];
    // console.log(this.category);
    // if(this.category === "news") {
    //   this.cancelCatRoute = '/news-list';
    // } else 
// this.postDate=new Date()
const today = new Date();
this.postDate={
  year: today.getFullYear(),
  month: today.getMonth() + 1,
  day: today.getDate()
};
    // this.postDate = today.toISOString().split('T')[0];
console.log(this.postDate,"post date");

    this.addNewsForm = new FormGroup({
      news_type: new FormControl(''),
      pdfurl: new FormControl('', [this.urlValidator]) // Custom URL validator
    });

    if(this.category === "gmp") {
      this.cancelCatRoute = '/gmp-list';
    } else if(this.category === "regulatory-guidelines") {
      this.cancelCatRoute = '/regulatory-guidelines-list';
    } 
    // else if(this.category === "business") {
    //   this.cancelCatRoute = '/business-list';
    // } else if(this.category === "products-services") {
    //   this.cancelCatRoute = '/products-services-list';
    // }

    this.addNewsForm = new FormGroup({
      news_type: new FormControl(),
      title: new FormControl(),
      pdfurl: new FormControl(),
      logo_title: new FormControl(),
      link: new FormControl(),
      logo_link: new FormControl(),
      news_content:new FormControl(),
      // news_content: new FormControl(),
      img: new FormControl(),
      // thumbnail: new FormControl(),
      logo_img: new FormControl(),
      video: new FormControl(),
      files: new FormControl(),
      subCatName: new FormControl(),
      activeTillDate: new FormControl(),
      status: new FormControl(),
    });
    this.addNewsForm = this.formBuilder.group({
      news_type: ['', []],
      title: ['', [Validators.required]],
      pdfurl: ['', []],
      logo_title: ['', [Validators.required]],
      link: ['', [Validators.required, Validators.pattern('https?://.+')]],
      logo_link: ['', [Validators.required]],
      news_content: ['', [Validators.required]],
      // news_content: ['', [Validators.required]],
      img: ['', [Validators.required]],
      // thumbnail: ['', [Validators.required]],
      logo_img: ['', [Validators.required]],
      video: ['', [Validators.required]],
      // files: ['', []],
      subCatName: [[], [Validators.required]],
      activeTillDate: [null, Validators.required],
      status: ['', []],
    });
    
    this.getAllSubCat();

    this.news_id = this.route.snapshot.paramMap.get('news_id');
    this.news_type = this.route.snapshot.paramMap.get('news_type');
    // console.log(this.news_id, this.news_type);
    if (this.news_id != undefined && this.news_id != '' && this.news_type != undefined && this.news_type != '') {
      this.editNews(this.news_id, this.news_type.split(" ")[0]);
    } else {
      this.addNewsForm.get('news_type').setValue('internal_news');
      this.addNewsForm.get('status').setValue('active');
      // this.addNewsForm.get('subCatName').setValue('All', { onlySelf: true });
    }
  }

  getAllSubCat() {
    this.LoaderService.showLoader()
    let catTypeSubCatApi: any;
    // if(this.category === "news") {
    //   catTypeSubCatApi = this.apiService.getAllSubCatNewsList();
    // } else 
    if(this.category === "gmp") {
      catTypeSubCatApi = this.apiService.getAllSubCatGmpList();
    } else if(this.category === "regulatory-guidelines") {
      catTypeSubCatApi = this.apiService.getAllSubCatGuidelinesList();
    } 
    // else if(this.category === "business") {
    //   catTypeSubCatApi = this.apiService.getAllSubCatBusinessList();
    // } else if(this.category === "products-services") {
    //   catTypeSubCatApi = this.apiService.getAllSubCatProductList();
    // }
    catTypeSubCatApi.subscribe((resp: any) => {
      this.SubCats = [];
      for(let i = 0; i < resp.data.length; i++) {
        if(resp.data[i].status === "active") {
          this.SubCats.push(resp.data[i].sub_category_name);
        }
      }
      this.LoaderService.hideLoader()

    });
    this.LoaderService.hideLoader()

  }
  onFileChange(event, set) {
    this.LoaderService.showLoader();
  
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const fileType = file.type;  // Get the MIME type of the file
  
      console.log('Selected file:', file);
      console.log('File MIME type:', fileType, set);
  
      // Check if the file is an image and if the set is 'img'
      if (set === 'img' && fileType.startsWith('image/')) {
        const img = new Image();
        const reader = new FileReader();
  
        reader.onload = (e: any) => {
          img.src = e.target.result;
        };
  
        img.onload = () => {
          // Check if the image dimensions are at least 700x700
          // if (img.width >= 700 && img.height >= 700) {
            // Valid image size (700x700 or greater)
            this.importImg.nativeElement.innerText = file.name;
            this.addNewsForm.get(set).setValue(file);
            this.LoaderService.hideLoader();
          // } else {
            // Image is too small
          //   this.LoaderService.hideLoader();
          //   this.toastr.error('Image dimensions must be at least 700x700 pixels.');
          // }
        };
  
        // Read the file as a data URL
        reader.readAsDataURL(file);
      } 
      else if (set === 'video' && (fileType.startsWith('video/') || fileType.startsWith('application/pdf') || file.name.endsWith('.pdf'))) {
        this.importVdo.nativeElement.innerText = file.name;
        this.addNewsForm.get(set).setValue(file);
        this.LoaderService.hideLoader();
      } 
      else if (set === 'logo_img' && fileType.startsWith('image/')) {
        this.importLogoImg.nativeElement.innerText = file.name;
        this.addNewsForm.get(set).setValue(file);
        this.LoaderService.hideLoader();
      } 
      else {
        this.LoaderService.hideLoader();
        this.toastr.error('Invalid file type. Please upload the correct file.');
      }
    }
    this.LoaderService.hideLoader()
  }
  
  

  async addNews() {

    if (
      this.addNewsForm.value.title.trim() == undefined ||
      this.addNewsForm.value.title.trim() == ''
    ) {
      this.toastr.error('All fields are required', '', {
        timeOut: 1000, 
        progressBar: true,
        closeButton: true   
      });
      this.LoaderService.hideLoader()

         return false;
    }
    if (this.addNewsForm.value.news_type == 'external_news') {
      if (
        this.addNewsForm.value.link.trim() == undefined ||
        this.addNewsForm.value.link.trim() == ''
      ) {
        this.toastr.error('Please Enter Link');
        this.LoaderService.hideLoader()

        return false;
      }
      if (
        this.addNewsForm.value.logo_title.trim() == undefined ||
        this.addNewsForm.value.logo_title.trim() == ''
        ) {
          this.LoaderService.hideLoader()

          this.toastr.error('Please Enter Logo Title');
        return false;
      }
     
    }
   
    if (this.addNewsForm.value.subCatName.length === 0 ) {
      this.toastr.error('Please Select Sub-category');
      this.LoaderService.hideLoader()

      return false;
    }
    // if (
    //   this.activeTillDate == undefined ||
    //   this.activeTillDate == '' || 
    //   this.activeTillDate == null 
    // ) {
    //   this.LoaderService.hideLoader()

    //   this.toastr.error('Please Enter Active Till Date');
    //   return false;
    // }
    if (this.news_id != undefined && this.news_id != '' && this.news_type != undefined && this.news_type != '') {
      this.updateNews(this.news_id, this.news_type.split(" ")[0]);
    } else {
      this.LoaderService.hideLoader()

      if (
        this.addNewsForm.value.img.name == undefined ||
        this.addNewsForm.value.img.name == ''
        ) {
          this.LoaderService.hideLoader()

          this.toastr.error('Please Select Image');
          return false;
        }
        console.log(this.addNewsForm.value);
        if (this.addNewsForm.value.news_type == 'internal_news') {
        if (
          (!this.addNewsForm.value.video.name && !this.addNewsForm.value.pdfurl.trim()) 
          ) {
            this.LoaderService.hideLoader()

          this.toastr.error('Please fill at-least one field of PPT or Pdf/video');
          return false;
        }
      }
      console.log(this.addNewsForm.value.news_type);
      // let date =this.activeTillDate
      let date = `${this.activeTillDate.month}/${this.activeTillDate.day}/${this.activeTillDate.year}`

      let formData = new FormData();
      if (this.addNewsForm.value.news_type == 'external_news') {
        formData.append('all_images', this.addNewsForm.get('img').value);
        formData.append('all_images2', this.addNewsForm.get('logo_img').value);
        formData.append('status', this.addNewsForm.get('status').value);
        formData.append('user_id', this._userId);
        formData.append('title', this.addNewsForm.get('title').value);
        formData.append('logo_title', this.addNewsForm.get('logo_title').value);
    
        formData.append('link', this.addNewsForm.get('link').value);
        formData.append('logo_link', this.addNewsForm.get('logo_link').value);
        for(let i = 0; i < this.addNewsForm.value.subCatName.length; i++) {
          formData.append('sub[]', this.addNewsForm.get('subCatName').value[i]);
        }
        formData.append('active_till', date);
        this.isAuthLoading = true;
        this.isAuthDisabled = true;
        let catTypeExAddApi: any;
        if(this.category === "gmp") {
          catTypeExAddApi = this.apiService.addExternalGmp(formData);
        } else if(this.category === "regulatory-guidelines") {
          catTypeExAddApi = this.apiService.addExternalGuidelines(formData);
        } 
        await catTypeExAddApi.subscribe((result) => {
          if (result.success) {
            this.LoaderService.hideLoader()

            this.isAuthLoading = false;
            this.isAuthDisabled = false;
            this.toastr.success(result.message);
            if(this.category === "gmp") {
              this.router.navigateByUrl('/gmp-list');
            } else if(this.category === "regulatory-guidelines") {
              this.router.navigateByUrl('/regulatory-guidelines-list');
            } 
          } else {
            this.isAuthLoading = false;
            this.isAuthDisabled = false;
            this.LoaderService.hideLoader()

            this.toastr.error(result.message);
          }
        });
      } else if (this.addNewsForm.value.news_type == 'internal_news') {
        formData.append('all_images', this.addNewsForm.get('img').value);
        formData.append('all_video', this.addNewsForm.get('video').value);
        formData.append('news_content', this.addNewsForm.get('news_content').value);
        formData.append('active_till', date);
        formData.append('status', this.addNewsForm.get('status').value);
        formData.append('user_id', this._userId);
        formData.append('title', this.addNewsForm.get('title').value);
        formData.append('pdfurl', this.addNewsForm.get('pdfurl').value);
        for(let i = 0; i < this.addNewsForm.value.subCatName.length; i++) {
          formData.append('sub[]', this.addNewsForm.get('subCatName').value[i]);
        }
        this.isAuthLoading = true;
        this.isAuthDisabled = true;
        let catTypeInAddApi: any;
        if(this.category === "gmp") {
          catTypeInAddApi = this.apiService.addInternalGmp(formData);
        } else if(this.category === "regulatory-guidelines") {
          catTypeInAddApi = this.apiService.addInternalGuidelines(formData);
        } 
        await catTypeInAddApi.subscribe((result) => {
          if (result.success) {
            this.LoaderService.hideLoader()

            this.isAuthLoading = false;
            this.isAuthDisabled = false;
            this.toastr.success(result.message);
            if(this.category === "gmp") {

              this.router.navigateByUrl('/gmp-list');
            } else if(this.category === "regulatory-guidelines") {
              this.router.navigateByUrl('/regulatory-guidelines-list');
            } 
          } else {
            this.LoaderService.hideLoader()

            this.isAuthLoading = false;
            this.isAuthDisabled = false;
            this.toastr.error(result.message);
          }
        });
      }
    }
    this.LoaderService.hideLoader()

  }


  ///////////////////////////////////////////////////////////////////////////////////////////////////////////
  async editNews(id, type) {

    let dataForForm = {
      id: id,
    };
    // console.log(dataForForm);
    if (type === 'Internal') {
      let catTypeInEditApi: any;
      // if(this.category === "news") {
      //   catTypeInEditApi = this.apiService.getInNewsById(dataForForm);
      // } else 
      if(this.category === "gmp") {
        catTypeInEditApi = this.apiService.getInGmpById(dataForForm);
      } else if(this.category === "regulatory-guidelines") {
        catTypeInEditApi = this.apiService.getInGuidelinesById(dataForForm);
      } 
      // else if(this.category === "business") {
      //   catTypeInEditApi = this.apiService.getInBusinessById(dataForForm);
      // } else if(this.category === "products-services") {
      //   catTypeInEditApi = this.apiService.getInProductById(dataForForm);
      // }
      await catTypeInEditApi.subscribe((result) => {
        if (result.success) {
          this.LoaderService.hideLoader()

          console.log(result.getData);
          let newsData: any = result.getData;
          this.addNewsForm.get('news_type').setValue('internal_news');
          this.addNewsForm.get('subCatName').setValue(newsData.sub_category_name);
          // this.addNewsForm.get('status').setValue(newsData.status);
          let date = new Date(newsData.active_till);
          let post=new Date(newsData.created_at)
          this.postDate= {
            day: post.getUTCDate() ,
            month: post.getUTCMonth(),
            year: post.getUTCFullYear()
        }
        console.log(this.postDate);
        
          this.activeTillDate= {
            day: date.getUTCDate() ,
            month: date.getUTCMonth() + 1,
            year: date.getUTCFullYear()
        }
          // console.log(date.getDate());
          this.addNewsForm.patchValue({
            title: newsData.title,
            pdfurl: newsData.pdfurl,
            news_content: newsData.news_content,
            img: newsData.news_image[0]?.src,
            video: newsData.news_video[0]?.src,
            // files: newsData.news_file[0]?.src,
            // thumbnail: newsData.thumbnail_img[0]?.src,
            // news_content: newsData.news_content,
            activeTillDate: {
              day: date.getUTCDate() + 1,
              month: date.getUTCMonth() + 1,
              year: date.getUTCFullYear()
          },
            // status: newsData.status,
          });
          if(newsData.status == "active") {
            this.addNewsForm.get('status').setValue('active');
          }
          setTimeout(() => {
            this.importImg.nativeElement.innerText = newsData.news_image[0]?.orgName;
            if(
              newsData.news_video[0]?.orgName === undefined || 
              newsData.news_video[0]?.orgName === '' || 
              newsData.news_video[0]?.orgName ===  null
            ) {
              this.importVdo.nativeElement.innerText = 'Upload Video/File';  
            } else {
              this.importVdo.nativeElement.innerText = newsData.news_video[0]?.orgName;
            }
            // if(
            //   newsData.news_file[0]?.orgName === undefined || 
            //   newsData.news_file[0]?.orgName === '' || 
            //   newsData.news_file[0]?.orgName === null
            // ) {
            //   this.importFile.nativeElement.innerText = 'Upload File';  
            // } else {
            //   this.importFile.nativeElement.innerText = newsData.news_file[0]?.orgName;
            // }
            // this.importThumbnailImg.nativeElement.innerText = newsData.thumbnail_img[0]?.orgName;
            // console.log(this.addNewsForm.get('status').value);
            this.LoaderService.hideLoader()

          }, 1000);
        } else {
          this.LoaderService.hideLoader()

          this.toastr.error(result.message);
        }
      });
    } else if (type === 'External') {
      let catTypeExEditApi: any;
      this.LoaderService.hideLoader()

      // if(this.category === "news") {
      //   catTypeExEditApi = this.apiService.getExNewsById(dataForForm);
      // } else 
      if(this.category === "gmp") {
        catTypeExEditApi = this.apiService.getExGmpById(dataForForm);
      } else if(this.category === "regulatory-guidelines") {
        catTypeExEditApi = this.apiService.getExGuidelinesById(dataForForm);
      } 
      // else if(this.category === "business") {
      //   catTypeExEditApi = this.apiService.getExBusinessById(dataForForm);
      // } else if(this.category === "products-services") {
      //   catTypeExEditApi = this.apiService.getExProductById(dataForForm);
      // }
      await catTypeExEditApi.subscribe((result) => {
        this.LoaderService.hideLoader()

        if (result.success) {
          console.log(result.getData);
          let newsData: any = result.getData;
          this.addNewsForm.get('news_type').setValue('external_news');
          this.addNewsForm.get('subCatName').setValue(newsData.sub_category_name);
          // this.addNewsForm.get('status').setValue(newsData.status);
          let date = new Date(newsData.active_till);
          console.log(date,"mydate");
          // this.activeTillDate=JSON.parse(newsData.active_till)
          let post=new Date(newsData.created_at)
          this.postDate= {
            day: post.getUTCDate() ,
            month: post.getUTCMonth(),
            year: post.getUTCFullYear()
        }
          this.addNewsForm.patchValue({
            title: newsData.title,
            //pdfurl:newsData.pdf,
            img: newsData.news_image[0]?.src,
            // thumbnail: newsData.thumbnail_img[0]?.src,
            link: newsData.link,
            logo_title: newsData.logo_title,
            logo_img: newsData.logo_image[0]?.src,
            logo_link: newsData.logo_link,
            activeTillDate: {
              day: date.getUTCDate() + 1,
              month: date.getUTCMonth() + 1,
              year: date.getUTCFullYear()
            },
            // status: newsData.status,
          });
          this.activeTillDate= {
            day: date.getUTCDate() ,
            month: date.getUTCMonth()+1 ,
            year: date.getUTCFullYear()
          },
          console.log(this.addNewsForm,"formdata");
          
          if(newsData.status == "active") {
            this.addNewsForm.get('status').setValue('active');
          }
          setTimeout(() => {
            this.importImg.nativeElement.innerText = newsData.news_image[0]?.orgName;
            if(
              newsData.logo_image[0]?.orgName === undefined || 
              newsData.logo_image[0]?.orgName === '' || 
              newsData.logo_image[0]?.orgName === null
            ) {
              this.importLogoImg.nativeElement.innerText = 'Upload Logo Image';  
            } else {
              this.importLogoImg.nativeElement.innerText = newsData.logo_image[0]?.orgName;
            }
            // this.importLogoImg.nativeElement.innerText = newsData.logo_image[0]?.orgName;
            // this.importThumbnailImg.nativeElement.innerText = newsData.thumbnail_img[0]?.orgName;
          }, 1000);
        } else {
          this.toastr.error(result.message);
        }
      });
    } else {
      this.LoaderService.hideLoader()

      this.toastr.error('No Data Found');
    }
    this.LoaderService.hideLoader()

  }


  ///////////////////////////////////////////////////////////////////////////////////////////////////
  async updateNews(id, type) {
    let formData = new FormData();
    if(
      this.addNewsForm.value.img?.name != undefined ||
      this.addNewsForm.value.img?.name != ''
    ) {
      formData.append('all_images', this.addNewsForm.get('img').value);
    }
    // if (
    //   this.addNewsForm.value.thumbnail.name != undefined ||
    //   this.addNewsForm.value.thumbnail.name != ''
    // ) {
    //   formData.append('thumb_file', this.addNewsForm.get('thumbnail').value);
    // }

    if (type == 'External') {
      if (
        this.addNewsForm.value.logo_img?.name != undefined ||
        this.addNewsForm.value.logo_img?.name != ''
      ) {
        formData.append('all_images2', this.addNewsForm.get('logo_img').value);
      } 
    }

    if (type == 'Internal') {
      formData.append('news_content', this.addNewsForm.get('news_content').value);
      if(
        this.addNewsForm.value.video?.name != undefined ||
        this.addNewsForm.value.video?.name != ''
      ) {
        formData.append('all_video', this.addNewsForm.get('video').value);
      }
      // if(
      //   this.addNewsForm.value.video?.name != undefined ||
      //   this.addNewsForm.value.video?.name != ''
      // ) {
      //   formData.append('all_file', this.addNewsForm.get('files').value);
      // }
    }

    // let date = JSON.stringify(this.activeTillDate)
    let date = `${this.activeTillDate.month}/${this.activeTillDate.day}/${this.activeTillDate.year}`
    console.log(date);
      if (type == 'External') {
        formData.append('status', this.addNewsForm.get('status').value == "" || this.addNewsForm.get('status').value == "inactive" ? "inactive" : "active");
        formData.append('user_id', this._userId);
        formData.append('title', this.addNewsForm.get('title').value);
        formData.append('link', this.addNewsForm.get('link').value);
        formData.append('logo_title', this.addNewsForm.get('logo_title').value);
        formData.append('logo_link', this.addNewsForm.get('logo_link').value);
        for(let i = 0; i < this.addNewsForm.value.subCatName.length; i++) {
          formData.append('sub[]', this.addNewsForm.get('subCatName').value[i]);
        }
        formData.append('active_till', date);
        console.log(date);
        // return
        
        this.isAuthLoading = true;
        this.isAuthDisabled = true;
        let catTypeExUpdateApi: any;
        // if(this.category === "news") {
        //   catTypeExUpdateApi = this.apiService.updateExternalNews(formData, id);
        // } else 
        if(this.category === "gmp") {
          catTypeExUpdateApi = this.apiService.updateExternalGmp(formData, id);
        } else if(this.category === "regulatory-guidelines") {
          catTypeExUpdateApi = this.apiService.updateExternalGuidelines(formData, id);
        } 
        // else if(this.category === "business") {
        //   catTypeExUpdateApi = this.apiService.updateExternalBusiness(formData, id);
        // } else if(this.category === "products-services") {
        //   catTypeExUpdateApi = this.apiService.updateExternalProduct(formData, id);
        // }
        await catTypeExUpdateApi.subscribe((result) => {
          if (result.success) {
            this.toastr.success(result.message);
            this.isAuthLoading = false;
            this.isAuthDisabled = false;
            // if(this.category === "news") {
            //   this.router.navigateByUrl('/news-list');
            // } else 
            if(this.category === "gmp") {
              this.router.navigateByUrl('/gmp-list');
            } else if(this.category === "regulatory-guidelines") {
              this.router.navigateByUrl('/regulatory-guidelines-list');
            } 
            // else if(this.category === "business") {
            //   this.router.navigateByUrl('/business-list');
            // } else if(this.category === "products-services") {
            //   this.router.navigateByUrl('/products-services-list');
            // }
          } else {
            this.isAuthLoading = false;
            this.isAuthDisabled = false;
            this.toastr.error(result.message);
          }
        });
      } else if (type == 'Internal') {
        formData.append('status', this.addNewsForm.get('status').value == "" || this.addNewsForm.get('status').value == "inactive" ? "inactive" : "active");
        formData.append('user_id', this._userId);
        formData.append('title', this.addNewsForm.get('title').value);
        formData.append('pdfurl', this.addNewsForm.get('pdfurl').value);
        // formData.append('news_content', this.addNewsForm.get('news_content').value);
        for(let i = 0; i < this.addNewsForm.value.subCatName.length; i++) {
          formData.append('sub[]', this.addNewsForm.get('subCatName').value[i]);
        }
        formData.append('active_till', date);
        this.isAuthLoading = true;
        this.isAuthDisabled = true;
        let catTypeInUpdateApi: any;
        // if(this.category === "news") {
        //   catTypeInUpdateApi = this.apiService.updateInternalNews(formData, id);
        // } else 
        if(this.category === "gmp") {
          catTypeInUpdateApi = this.apiService.updateInternalGmp(formData, id);
        } else if(this.category === "regulatory-guidelines") {
          catTypeInUpdateApi = this.apiService.updateInternalGuidelines(formData, id);
        } 
        // else if(this.category === "business") {
        //   catTypeInUpdateApi = this.apiService.updateInternalBusiness(formData, id);
        // } else if(this.category === "products-services") {
        //   catTypeInUpdateApi = this.apiService.updateInternalProduct(formData, id);
        // }
        await catTypeInUpdateApi.subscribe((result) => {
          if (result.success) {
            this.isAuthLoading = false;
            this.isAuthDisabled = false;
            this.toastr.success(result.message);
            // if(this.category === "news") {
            //   this.router.navigateByUrl('/news-list');
            // } else 
            if(this.category === "gmp") {
              this.router.navigateByUrl('/gmp-list');
            } else if(this.category === "regulatory-guidelines") {
              this.router.navigateByUrl('/regulatory-guidelines-list');
            } 
            // else if(this.category === "business") {
            //   this.router.navigateByUrl('/business-list');
            // } else if(this.category === "products-services") {
            //   this.router.navigateByUrl('/products-services-list');
            // }
          } else {
            this.isAuthLoading = false;
            this.isAuthDisabled = false;
            this.toastr.error(result.message);
          }
        });
      }
  }
  handleChange(eve){
    var target = eve.target;
    if(target.checked){
      // document.getElementById('').setValue('')
    this.addNewsForm.get('title').setValue('')
    this.addNewsForm.get('subCatName').setValue('')
    // this.addNewsForm.get('img').setValue(''),
    // this.importImg.nativeElement.set('')
    console.log(this.addNewsForm.get('img').value)
    // this.addNewsForm.get('active_till')
    console.log('checked')
    }
  }

}
